import { Routes, Route, Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../store';
import Login from '../pages/Login/login';
import Dashboard from '../pages/Dashboard/Dashboard';
import CryptoTest from '../pages/CryptoTest/CryptoTest';
import AppLayout from '../layouts/Applayout';
import TestDashboard from '../pages/TestDashboard/TestDashboard';
import PrivacyPolicy from '../pages/auth/PrivacyPolicy';
import EGovernment from '../pages/auth/EGovernment';
import StudentAdmssion from 'pages/StudentAdmssion';
import StudentPromotion from 'pages/StudentPromotion';
import StudentTcDetails from 'pages/StudentTcDetails';
import FinancialTracker from 'pages/FinancialTracker';
import ResetPassword from '../pages/reset-password';
import StudentExposureVisit from '../pages/student/student-exposure-visit/Student-exposure-visit';
/**
 *
 * Guard: redirects to login if session is not loaded.
 * Wraps AppLayout so all authenticated routes are protected.
 */
function PrivateRoute() {
  const loaded = useSelector((state: RootState) => state.session.loaded);
  if (!loaded) return <Navigate to="/" replace />;
  return <AppLayout />;
}

export default function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/auth/privacy_policy" element={<PrivacyPolicy />} />
      <Route path="/auth/eGovernment/IT" element={<EGovernment />} />

      <Route element={<PrivateRoute />}>
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/crypto-test" element={<CryptoTest />} />
        <Route path="/testDashboard" element={<TestDashboard />} />
        <Route
          path="/student/student-admission"
          element={<StudentAdmssion />}
        />
        <Route
          path="/student/student-promotion"
          element={<StudentPromotion />}
        />
        <Route
          path="/student/student-tc-details"
          element={<StudentTcDetails />}
        />
        <Route
          path="/school/financial-tracker"
          element={<FinancialTracker />}
        />
        <Route
          path="/student/student-exposure-visit"
          element={<StudentExposureVisit />}
        />
        <Route path="/reset-password" element={<ResetPassword />} />
      </Route>
    </Routes>
  );
}
